import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LocaleService } from '../services/locale.service';

@Pipe({ name: 'localDate', pure: false, standalone: true })
export class LocalDatePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor(private localeService: LocaleService) {
    this.datePipe = new DatePipe(this.localeService.getLocale());
  }

  transform(value: any, format: string = 'shortDate'): string | null {
    // DatePipe needs the locale at construction, recreate if locale changed
    const locale = this.localeService.getLocale();
    if (!this.datePipe || (this.datePipe as any)._localeId !== locale) {
      this.datePipe = new DatePipe(locale);
    }
    return this.datePipe.transform(value, format);
  }
}
